import $ from "jquery";

const axios = {
  post: function posrtRequest(options) {
    this.request({ ...options, method: "POST" });
  },
  request: function request(options) {
    return $.ajax({
      url: options.url,
      type: options.method,
      headers: {
        accept: options.headers.accept || "application/json; charset=UTF-8",
        "content-type": options.headers["content-type"] || "application/json",
        authorization: options.headers.authorization || null,
      },
      data: JSON.stringify(options.data),
    });
  },
};

const options = {
  method: "POST",
  url: "https://esputnik.com/api/v1/contacts",
  headers: {
    accept: "application/json; charset=UTF-8",
    "content-type": "application/json",
    authorization:
      "Basic cXdlcXdlcTpCMDk4NjA5QTEwOEQwNTQ3ODI0ODBCOTcxMkUxQkE5NQ==",
  },
};

const addContacts = (phoneNumber) => {
  axios
    .request({
      ...options,
      data: {
        contacts: [
          {
            channels: [{ type: "sms", value: String(phoneNumber) }],
            externalCustomerId: String(phoneNumber),
          },
        ],
        contactFields: ["sms", "externalCustomerId"],
        dedupeOn: "externalCustomerId",
        eventKeyForNewContacts: "newContactweb",
      },
    })
};

export default addContacts;
